export const accountLinkingConstants = {
    GRANT_TYPE: "authorization_code",
    ALEXA_APP_CLIENT_TYPE: "alexapp",
    GOOGLE_HOME_CLIENT_TYPE: "googlehome",
    API_KEY: "account_linking"
}